import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';
import {
    showAllStrategies,
    showStrategyEditor,
    closeStrategyEditor,
    updateStategyDetails,
    saveNewStrategy,
} from '../../../actions/data';
import './StrategyList.css';
import i18n from './../../../i18n';
import StrategyRow from './StrategyRow.js';
import StrategyEditor from '../StrategyEditor/StrategyEditor.js';
import ImportantInfoModal from '../ImportantInfoModal/ImportantInfoModal.js';

import 'react-tabs/style/react-tabs.css';

export const KEY_METRICS = [
    'performance',
    'income',
    'risk',
    'sharpe',
    'fees',
]

class StrategyList extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            menuIsOpen: false,
            currPage: 0,
            numPerPage: 10,
            importantInfoOpen: false,
            searchTerm: '',

        };

        this.paginate = this.paginate.bind(this);
        this.handleShowEditor = this.handleShowEditor.bind(this);
        this.handleShowImportantInfoModal = this.handleShowImportantInfoModal.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    setMenuIsOpen = (menuIsOpen) => {
        this.setState({ menuIsOpen });
    };

    paginate({ selected }) {
        this.setState({
            currPage: selected,
        });
    }

    handleShowEditor() {
        this.setState({
            importantInfoOpen: false,
        });
        this.props.showStrategyEditor(null);
    }

    handleShowImportantInfoModal() {
        this.setState({
            importantInfoOpen: true,
        });
    }

    handleTabSelect(index) {
        this.setState({ tabIndex: index }); // Update the selected tab index when a tab is selected
    }
    handleSearchChange(event) {
        this.setState({ searchTerm: event.target.value });
    }

    handleClearSearch = () => {
        this.setState({ searchTerm: '' });
    }

    render() {
        const {
            currPage,
            numPerPage,
            importantInfoOpen,

        } = this.state;

        const {
            closeStrategyEditor,
            updateStategyDetails,
            saveNewStrategy,
        } = this.props;

        const {
            personalStrategies,
            strategyIdToShow,
            strategyEditorVisible,
            strategyToEdit,
            strategySaveInProgress,
        } = this.props.data;

        const strategyEditor = <StrategyEditor
            key={strategyToEdit ? strategyToEdit.id : 'new-strategy-editor'}
            showEditor={strategyEditorVisible}
            strategyToEdit={strategyToEdit}
            closeEditor={closeStrategyEditor}
            saveNewStrategy={saveNewStrategy}
            updateStategyDetails={updateStategyDetails}
            params={this.props.params}
            typeaheadUrl={`${process.env.REACT_APP_DPD_URL}/api/securityfund/typeahead/`}
            checkTickersUrl={`${process.env.REACT_APP_DPD_URL}/api/securityfund/ticker_names/`}
            benchmarks={this.props.data.benchmarks}
        />

        if (personalStrategies && personalStrategies.length > 0) {
            const filteredStrategies = personalStrategies
                .filter(strategy => strategy.name.toLowerCase().includes(this.state.searchTerm.toLowerCase()));

            const min = currPage * numPerPage;
            const max = min + numPerPage;
            const pageCount = Math.ceil(filteredStrategies.length / numPerPage);
            const personalStrategiesToList = filteredStrategies.slice(min, max);


            return (
                <div className='strategylist'>

                    <div className='portfolio-title'>{i18n.t('my-portfolios')}</div>

                    {!this.state.menuIsOpen && (
                        <div className='search-container'>
                            <input
                                type="text"
                                placeholder="Search by Portfolio Name"
                                value={this.state.searchTerm}
                                onChange={this.handleSearchChange}
                                className="search-input"
                            />
                            <button onClick={this.handleClearSearch} className="clear-button">Clear</button>
                        </div>
                    )}
                    {!strategyIdToShow ?
                        <div className='headers'>
                            <div className='menu title'>{i18n.t('name')}
                            </div>
                            <div className='name title'></div>
                            <div className='last-updated title'>{i18n.t('last-updated')}</div>
                            <div className='statistics'>
                                {
                                    KEY_METRICS.map(metric => {
                                        return (
                                            <div className={'stat-' + metric} key={'stat-' + metric}>
                                                <div className='stat-heading'>
                                                    <div className='title'>{i18n.t(metric)}</div>
                                                    <div className='more-info' >
                                                        <FontAwesomeIcon data-tip data-for={metric + '-desc'} icon='question-circle' size='sm' />
                                                    </div>
                                                </div>
                                                <ReactTooltip id={metric + '-desc'} type='light' className='tooltip' effect='float'>
                                                    {i18n.t(metric + '-desc')}
                                                </ReactTooltip>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        : null}
                    {personalStrategiesToList.map((strategy, index) => {
                        if (strategyIdToShow === null || strategy.id === strategyIdToShow) {
                            return (
                                <StrategyRow
                                    personalStrategy={strategy}
                                    openMenu={strategyIdToShow === null ? false : true}
                                    key={strategy.id}
                                    striped={index % 2 !== 0} // Make every even row stripped                                      
                                    saveInProgress={strategySaveInProgress && strategySaveInProgress === strategy.id}
                                    menuIsOpen={this.state.menuIsOpen}
                                    setMenuIsOpen={this.setMenuIsOpen}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                    {!strategyIdToShow ?
                        <div className='last-row'>
                            <div className='row-pagination'>
                                <ReactPaginate
                                    previousLabel={<FontAwesomeIcon icon='chevron-left' size='xs' />}
                                    nextLabel={<FontAwesomeIcon icon='chevron-right' size='xs' />}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.paginate}
                                    containerClassName={'pagination'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-item'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'pageLink'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'pageLink'}
                                    activeClassName={'active'}
                                    disabledClassName={'disabled'}
                                />
                            </div>
                            <div className='new-strategy'>
                                <button onClick={this.handleShowEditor} >{i18n.t('new-strategy')}</button>
                            </div>
                        </div>
                        : null}
                    {strategyEditor}
                </div>
            );
        } else if (personalStrategies && personalStrategies.length === 0) {
            return (
                <div className='no-strategies'>
                    <div className='no-strategies-label'>
                        <h4>{i18n.t('no-strategies')}</h4>
                    </div>
                    <div className='new-strategy'>
                        {/* Add the 'ADD' button without passing in a PersonalStrategy to load into it */}
                        <button onClick={this.handleShowImportantInfoModal} >{i18n.t('new-strategy')}</button>
                    </div>

                    {/* Modal for Important Information - only shown when a new strategy
                    is clicked and none already exist */}
                    <ImportantInfoModal
                        isOpen={importantInfoOpen}
                        onClose={this.handleShowEditor}
                    />

                    {/* Add the StrategyEditor that will get opened when 'Add' is pressed
                        or an individual row is edited */}
                    {strategyEditor}

                </div>
            );
        }
        return (
            <div className='loading-strategies'>
                <h3>{i18n.t('loading')}</h3>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        data: state.data,
        params: state.params,
    };
}

export default connect(mapStateToProps,
    {
        showAllStrategies,
        showStrategyEditor,
        closeStrategyEditor,
        updateStategyDetails,
        saveNewStrategy,
    })(StrategyList);